import React from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fab from "@mui/material/Fab";
import i18n from "../../constants/i18n";
import { BACK_TO_TOP_PAGES_ARRAY } from "../../constants/input-entries-constants";
import { backToTop } from "../../helpers/et3-back-top";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const KhattabatBackToTop = withLiteObserverAndTheme<{
  refDiv: React.RefObject<HTMLDivElement>;
}>((props) => {
  const { refDiv } = props;
  const shouldShow = BACK_TO_TOP_PAGES_ARRAY.includes(
    getCoreHistoryStore().pageName.get()
  );

  return !shouldShow ? null : (
    <Fab
      color="primary"
      size="medium"
      aria-label={i18n.get("KHATTABAT_BACK_TO_TOP")}
      onClick={() => backToTop(refDiv)}
      sx={{ position: "fixed", bottom: 24, right: 24 }}
    >
      <KeyboardArrowUpIcon />
    </Fab>
  );
});

export default KhattabatBackToTop;
